import React from "react";
import styles from "./OccupiedField.module.scss";
import { useTheme } from "../../../hooks/useSingleton";

interface Props {
	moreHorizon?: React.JSX.Element;
	username: string;
}

/**
 * Blocks a field out and shows who is editing it.
 */
function OccupiedField(props: Props) {
	const { moreHorizon, username } = props;

	const color = useTheme();

	return (
		<div className={styles.occupiedField_wrapper}>
			<div className={styles.fieldWrapper}>
				<div style={{ color: color.text.primary }} className={styles.userName_text}>
					{username} is editing
				</div>
				{/* The 3 divs here are the 3 dots that bounce around when someone is editing, do not delete */}
				<div className={styles.bouncingLoader}>
					<div />
					<div />
					<div />
				</div>
			</div>
			{moreHorizon && moreHorizon}
		</div>
	);
}

export default OccupiedField;
